export const usageCautionsSafe = (
  usageCautions: {
    content: string
  }[],
): string[] => {
  if (!usageCautions) return []
  if (!Array.isArray(usageCautions)) return []

  return usageCautions.map((item) => item.content || '')
}
